"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimepickerSwitch = exports.NumberStepper = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _button = _interopRequireDefault(require("../Button/button"));

var _form = _interopRequireDefault(require("../Form/form"));

var _icon = _interopRequireDefault(require("../Icon/icon"));

var _numberInput = _interopRequireDefault(require("../NumberInput/numberInput"));

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MERIDIAN = {
  AM: 'AM',
  PM: 'PM'
};

var NumberStepper =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NumberStepper, _React$PureComponent);

  function NumberStepper(props) {
    var _this;

    _classCallCheck(this, NumberStepper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberStepper).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "increment", function () {
      var value = _this.state.value;
      var _this$props = _this.props,
          minValue = _this$props.minValue,
          maxValue = _this$props.maxValue;
      var newValue = value >= maxValue ? minValue : value + 1;

      _this.setState({
        value: newValue
      }, _this.onChange);
    });

    _defineProperty(_assertThisInitialized(_this), "decrement", function () {
      var value = _this.state.value;
      var _this$props2 = _this.props,
          minValue = _this$props2.minValue,
          maxValue = _this$props2.maxValue;
      var newValue = value <= minValue ? maxValue : value - 1;

      _this.setState({
        value: newValue
      }, _this.onChange);
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      _this.props.onChange(_this.state.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyboardChange", function (event) {
      var value = Number.parseInt(event.target.value) || 0;
      var _this$props3 = _this.props,
          minValue = _this$props3.minValue,
          maxValue = _this$props3.maxValue;

      if (!value || value >= minValue && value <= maxValue) {
        _this.setState({
          value: value
        }, _this.onChange);
      }
    });

    _this.state = {
      value: props.value || 0
    };
    _this.id = _this.props.id || (0, _unique.default)();
    return _this;
  }

  _createClass(NumberStepper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var value = this.props.value;
      if (!value || prevProps.value === value) return;
      this.setState({
        value: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          minValue = _this$props4.minValue,
          maxValue = _this$props4.maxValue,
          minLength = _this$props4.minLength;
      var value = minLength ? String(this.state.value).padStart(minLength, 0) : this.state.value;
      return _react.default.createElement(_form.default.FieldGroup, {
        id: this.id
      }, _react.default.createElement(_numberInput.default, {
        minValue: minValue,
        maxValue: maxValue,
        value: value,
        onChange: this.onKeyboardChange
      }), _react.default.createElement(_form.default.FieldGroup.StackedButtons, null, _react.default.createElement(_button.default, {
        secondary: true,
        onClick: this.increment
      }, _react.default.createElement(_icon.default, {
        name: _icon.default.EXPAND_LESS
      })), _react.default.createElement(_button.default, {
        secondary: true,
        onClick: this.decrement
      }, _react.default.createElement(_icon.default, {
        name: _icon.default.EXPAND_MORE
      }))));
    }
  }]);

  return NumberStepper;
}(_react.default.PureComponent);

exports.NumberStepper = NumberStepper;

var TimepickerSwitch =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TimepickerSwitch, _React$Component);

  function TimepickerSwitch(props) {
    var _this2;

    _classCallCheck(this, TimepickerSwitch);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TimepickerSwitch).call(this, props));

    _defineProperty(_assertThisInitialized(_this2), "meridianOnClick", function () {
      var meridian = _this2.state.meridian;
      var AM = MERIDIAN.AM,
          PM = MERIDIAN.PM;
      var newMeridian = meridian === AM ? PM : AM;

      _this2.setState({
        meridian: newMeridian
      }, _this2.onChange);
    });

    _defineProperty(_assertThisInitialized(_this2), "onChange", function () {
      _this2.props.onChange(_this2.state.meridian);
    });

    _this2.state = {
      meridian: props.defaultMeridian || MERIDIAN.AM
    };
    return _this2;
  }

  _createClass(TimepickerSwitch, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var defaultMeridian = this.props.defaultMeridian;
      if (!defaultMeridian || prevProps.defaultMeridian === defaultMeridian) return;
      this.setState({
        meridian: defaultMeridian
      });
    }
  }, {
    key: "render",
    value: function render() {
      var uid = this.props.id || (0, _unique.default)();
      return _react.default.createElement("div", {
        className: "co-timepicker__switch"
      }, _react.default.createElement("input", {
        type: "checkbox",
        id: uid,
        onClick: this.meridianOnClick
      }), _react.default.createElement("label", {
        htmlFor: uid
      }, this.state.meridian));
    }
  }]);

  return TimepickerSwitch;
}(_react.default.Component);

exports.TimepickerSwitch = TimepickerSwitch;
NumberStepper.propTypes = {
  minValue: _propTypes.number.isRequired,
  maxValue: _propTypes.number.isRequired,
  minLength: _propTypes.number,
  value: _propTypes.number,
  onChange: _propTypes.func
};
TimepickerSwitch.Meridian = MERIDIAN;
TimepickerSwitch.propTypes = {
  id: _propTypes.string,
  defaultMeridian: (0, _propTypes.oneOf)([MERIDIAN.AM, MERIDIAN.PM]),
  onChange: _propTypes.func
};
NumberStepper.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "increment",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "decrement",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onKeyboardChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "NumberStepper",
  "props": {
    "minValue": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": ""
    },
    "maxValue": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": ""
    },
    "minLength": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
TimepickerSwitch.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "meridianOnClick",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "TimepickerSwitch",
  "props": {
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "defaultMeridian": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'AM'",
          "computed": false
        }, {
          "value": "'PM'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};